// extracted by mini-css-extract-plugin
export default {"modal":"AuthModal_modal__WWq+8","header":"AuthModal_header__GQJ1x","body":"AuthModal_body__V8d8f","row":"AuthModal_row__WcFgU","footer":"AuthModal_footer__pv-wl"};